enum Locale {
    Italian = "it-IT",
    English = "en-US"
}

export default Locale;